import { atom, selector, selectorFamily } from "recoil";
import { mapTimeControllerWithID } from "./MapTimeControllerState";
import { csRevision } from "./CsRevisionState";

/**
 * 断面図タイムコントローラーリスト
 */
export const csTimeControllerListState = atom({
  key: 'csTimeControllerListState',
  default: [],
  dangerouslyAllowMutability: true
});

/**
 * 平面図タイムコントローラーの子に断面図タイムコントローラを追加する。また断面図タイムコントローラリストにタイムコントローラーを追加する
 */
export const addCsTimeControllerSelector = selector({
  key: 'addCsTimeControllerSelector',
  set: ({get, set}, {mapContentsId, timeController}) => {
    const oldList = get(csTimeControllerListState);
    const idx = oldList.findIndex(target => {
      return target.id === timeController.id;
    });
    if (idx !== -1) return;

    const parentTimeController = get(mapTimeControllerWithID(mapContentsId));
    //親の自動更新を反映させる
    timeController.changeAutoRefresh(parentTimeController.autoRefresh);
    //親の選択時制を適用させる
    timeController.setCurrentTime(parentTimeController.currentTime);

    parentTimeController.addTimeController(timeController);

    //断面図再描画
    set(csRevision)

    const newList = [...oldList, timeController];
    set(csTimeControllerListState, newList);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});

/**
 * 断面図タイムコントローラリストからタイムコントローラーを削除する
 */
export const removeCsTimeControllerSelector = selector({
  key: 'removeCsTimeControllerSelector',
  set: ({get, set}, {timeController}) => {
    // 平面図タイムコントローラーの子から断面図タイムコントローラを削除する処理は不要（平面図のremoveTimeControllerがpurgeChildTimeControllerする）
    // const parentTimeController = get(mapTimeControllerWithID(mapContentsId));
    // parentTimeController.removeTimeController(timeController);

    const oldList = get(csTimeControllerListState);
    const idx = oldList.findIndex(target => {
      return target.id === timeController.id;
    });
    if (idx === -1) return;

    const newList = [...oldList.slice(0, idx), ...oldList.slice(idx + 1)];
    set(csTimeControllerListState, newList);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});

export const csTimeControllerWithID = selectorFamily({
  key: 'csTimeControllerWithId',
  get: (id) => ({get}) => {
    const list = get(csTimeControllerListState);
    const idx = list.findIndex(target => {
      return target.id === id;
    });
    if (idx === -1) return;
    return list[idx];
  },
  dangerouslyAllowMutability: true
});
